import ModalVideo from './ModalVideo'
import LoadNextPost from './LoadNextPost'

export default class {
  constructor() {

    const domModalVideo = document.querySelectorAll('[data-js="modal-video"]')
    if (domModalVideo) domModalVideo.forEach((domModalVideo) => new ModalVideo(domModalVideo));

    // 投稿の追加読み込み機能
    const domLoadNextPost = document.querySelector('[data-js="movie-viewmore-posts"]');
    if (domLoadNextPost) {
      new LoadNextPost(domLoadNextPost);
    }
  }
}
